const projects = [
    // {
    //     id: '1',
    //     name: 'PixelWave',
    //     desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.'
    // },
    // {
    //     id: '2',
    //     name: 'CodeCrafters',
    //     desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.'
    // },
    // {
    //     id: '3',
    //     name: 'ByteStream',
    //     desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.'
    // },
    // {
    //     id: '4',
    //     name: 'WebWhiz',
    //     desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.'
    // },
    // {
    //     id: '5',
    //     name: 'Test Project',
    //     desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.'
    // },
    {
        id: 'mysolarsite',
        name: 'MySolarSite',
        desc: `<div>
                    <div>I built a Solar Energy Monitoring Dashboard that tracks multiple solar sites in real time. It shows key data in an easy-to-use list and map view.</div>
                    <div>
                    <h5>Key Features:</h5>

                    <h6>Dashboard Overview:</h6>
                    <ul>
                        <li>Solar, Load, and Genset Power & Energy</li>
                        <li>CO2 Emission Saved & Trees Planted</li>
                        <li>Grid Import & Export</li>
                    </ul>
                    
                    <h6>List View:</h6>
                    <ul>
                        <li>Site details (status, alarms, inverters, power sources)</li>
                        <li>Alarm categories: Critical, Major, Minor, Event, All OK</li>
                    </ul>

                    <h6>Single Site Dashboard:</h6>
                    <ul>
                        <li>Real-time Yield Data (Today, Monthly, Yearly, Lifetime)</li>
                        <li>Energy and Power Trend Analytics</li>
                        <li>Installed Devices</li>
                        <li>In-depth analytics of each device's parameters </li>
                    </ul>   
                    </div>
                </div>`,
        images: 16,
        imagesMimeType: 'png'
    },
    {
        id: 'ecm',
        name: 'ECM',
        desc: "ECM is a GSM data based enhanced communication gateway for data collection of site equipment. It is capable of forming a virtual bridge between site hardware and central server, allowing multiple possibilities being a versatile Remote Monitoring System. <br> ECM polls each connected hardware (module) sequentially to collect LIVE data which is then embedded into standard TCP/IP protocol so as to be sent to the central server. Thus near real time monitoring and reporting is conveniently accessible to the concerned and authorized personnel anywhere in the world. Moreover, the ECM is capable of remote device management i.e. changing internal settings of devices on request from/through central server.",
        images: 3
    },
    {
        id: 'KibbleDispenser',
        name: 'Houndsy Kibble Dispenser',
        desc: "I worked as a web developer on Houndsy.com, an e-commerce platform built on Shopify. My role involved customizing the Shopify theme, optimizing the user experience, and enhancing site functionality using Liquid, HTML, CSS, JavaScript, and Shopify APIs. I implemented design improvements, streamlined product displays, and ensured seamless performance to enhance the online shopping experience for pet owners.",
        images: 0,
        imagesMimeType: 'png'
    },
    {
        id: 'WelcomeToTheTribe',
        name: 'Welcome To The Tribe',
        desc: "",
        images: 0,
        imagesMimeType: 'jpg'
    },
    {
        id: 'gamer.jetzt',
        name: 'gamer.jetzt',
        desc: "",
        images: 0,
        imagesMimeType: 'jpg'
    },
    {
        id: 'awenyx.com',
        name: 'awenyx.com',
        desc: "",
        images: 0,
        imagesMimeType: 'png'
    },
    {
        id: 'HeyAllergy',
        name: 'HeyAllergy',
        desc: "",
        images: 0,
        imagesMimeType: 'jpg'
    },
    {
        id: 'porta.neonrain.tv',
        name: 'porta.neonrain.tv',
        desc: "",
        images: 0,
        imagesMimeType: 'jpg'
    },
    {
        id: 'AgencyWebsite',
        name: 'Agency Website',
        desc: "",
        images: 0,
        imagesMimeType: 'jpg'
    },
    {
        id: 'TKPets',
        name: 'TKPets',
        desc: "",
        images: 0,
        imagesMimeType: 'png'
    },
    {
        id: 'Symmetric',
        name: 'Symmetric',
        desc: "",
        images: 0,
        imagesMimeType: 'jpg'
    },
    {
        id: 'NotoxSkin',
        name: 'NotoxSkin',
        desc: "",
        images: 0,
        imagesMimeType: 'jpg'
    },
    {
        id: 'Donnawear',
        name: 'Donnawear',
        desc: "",
        images: 0,
        imagesMimeType: 'jpg'
    },
    {
        id: 'Grouply',
        name: 'Grouply',
        desc: "",
        images: 0,
        imagesMimeType: 'jpg'
    },
    {
        id: 'ProficientDigital',
        name: 'Proficient Digital',
        desc: "",
        images: 0,
        imagesMimeType: 'jpg'
    },
    {
        id: 'PearPixels',
        name: 'PearPixels',
        desc: "",
        images: 0,
        imagesMimeType: 'jpg'
    },
    {
        id: 'BellaireJewishCenter',
        name: 'Bellaire Jewish Center',
        desc: "",
        images: 0,
        imagesMimeType: 'jpg'
    },
    {
        id: 'StudioOnSunset',
        name: 'Studio On Sunset',
        desc: "",
        images: 0,
        imagesMimeType: 'png'
    },
    {
        id: 'Bankiom',
        name: 'Bankiom',
        desc: "",
        images: 0,
        imagesMimeType: 'jpg'
    },
    {
        id: 'Entrupy',
        name: 'Entrupy',
        desc: "",
        images: 0,
        imagesMimeType: 'jpg'
    },
    {
        id: 'ExploreQuran',
        name: 'Explore Quran',
        desc: "",
        images: 0,
        imagesMimeType: 'jpg'
    },
    {
        id: 'Malice',
        name: 'Malice',
        desc: "",
        images: 0,
        imagesMimeType: 'jpg'
    }
];
export default projects;